import { ERROR, FETCH_PROJECT_SUCCESS } from "../project/projTypes";
import {
  SHOW_CREATE_PROJECT, HIDE_CREATE_PROJECT, SHOW_LOADER, REFRESH_APP, HIDE_LOADER, SET_VIEW, SHOW_UPDATE_PROJ, SHOW_DEL_PROJECT, HIDE_DEL_PROJECT, DESTROYED_GRID, SHOW_COPY_PROJECT, HIDE_COPY_PROJECT, HIDE_UPDATE_PROJ, SHOW_TAGS, ASSIGN_TAGS, RESET_UPDTAG, HIDE_TAGS, SHOW_PKGS, HIDE_PKGS, CREATE_PKG, HIDE_PKG, UPDATE_PKG, CHANGE_WS_TAB, FETCH_LOOKUP_START, FETCH_LOOKUP_SUCCESS, FETCH_LOOKUP_FAILURE,
  CONF_ROUTING_CHECK_SUCCESS,
  CONF_ROUTING_CHECK_START,
  CONF_ROUTING_CHECK_FAILURE,
  GET_CONF_SESSIONID_START,
  GET_CONF_SESSIONID_FAILURE,
  GET_CONF_SESSIONID_SUCCESS,
  CONFIT_CREATE_QUOTE_SUCCESS,
  CONFIT_CREATE_QUOTE_START,
  CONFIT_CREATE_QUOTE_FAILURE,
  SET_CONF_INIT,
  CONFIT_UPDATE_QUOTE_START,
  CONFIT_UPDATE_QUOTE_FAILURE,
  CONFIT_UPDATE_QUOTE_SUCCESS
} from "./ctrlTypes";
import { endDest, projectStatus, currencies, priceList, configJSON, division_code, pkgStatus, fiscalYear, tagStatus, quotePriorityStatus, pricingTypeStatus, lateReasonCodes } from './vals'
import i18n from "i18next";


export const initialState = {
  showNewProj: false,
  loading: false,
  refresh: false,
  hideGrid: true,
  hideTiles: false,
  updProject: false,
  copyProject: false,
  deleteProject: false,
  showPkgs: false,
  showTags: false,
  crPkg: false,
  updPkg: false,
  destroyedGrid: false,
  labeltoDisplay: i18n.t('Tiles View'),
  labeltoDisplayNew: { "label": i18n.t('Tiles View'), "en": "Tiles View" },
  data: [],
  packages: [],
  pkg: [],
  techTypes: [],
  categories: [],
  tags: "",
  updTag: false,
  endDestOPt: endDest,
  pricingRegion: endDest,
  projStatus: projectStatus,
  salesChannelName: [],
  currencies: currencies,
  pkgStatus: pkgStatus,
  quotePriorityStatus: quotePriorityStatus,
  pricingTypeStatus: pricingTypeStatus,
  lateReasonCodes: lateReasonCodes,
  priceList: priceList,
  configJSON: configJSON,
  division_code: division_code,
  tagStatus: tagStatus,
  waso: [],
  datasetsLkp: {
    'Common': [],
    'DP Flow': [],
    'Flow': [],
    'Pressure': [],
    'Temperature': [],
    'Process Level': [],
    'DP Level': [],
    'Vanessa': [],
    'Documents & Order Services': [],
    'Buy Resale': [],
    'Accs, Parts & Spares': [],
    'All Instrumentation': [],
  },
  buLkp: [],
  priceListLkp: [],
  commercialTypes: [],
  commercialProducts: [],
  nonConfigProducts: [],
  wsTabValue: 'Instrumentation',
  templates: [],
  userGuides: [],
  routingCheckData: null,
  confSessionIDData: null,
  confCreateQuoteData: null,
  confUpdateQuoteData: null,
}



export const ctrlsReducer = (state = initialState, action) => {
  let fiscYr = [];
  switch (action.type) {
    case SHOW_CREATE_PROJECT:
      return {
        ...state,
        showNewProj: action.payload.showNewProj
      }
    case HIDE_CREATE_PROJECT:
      return {
        ...state,
        showNewProj: false
      }
    case SHOW_LOADER:
      return {
        ...state,
        loading: action.payload
      }
    case REFRESH_APP:
      return {
        ...state,
        refresh: action.payload
      }
    case HIDE_LOADER:
      return {
        ...state,
        loading: action.payload
      }
    case SHOW_UPDATE_PROJ:
      return {
        ...state,
        updProject: action.payload.updProj,
        data: action.payload.data
      }
    case HIDE_UPDATE_PROJ:
      return {
        ...state,
        updProject: action.payload
      }
    case SHOW_COPY_PROJECT:
      return {
        ...state,
        copyProject: action.payload.copyProj,
        data: action.payload.data
      }
    case HIDE_COPY_PROJECT:
      return {
        ...state,
        copyProject: action.payload
      }
    case SET_VIEW:
      return {
        ...state,
        hideGrid: action.payload.hideGrid,
        hideTiles: action.payload.hideTiles,
        labeltoDisplay: action.payload.labeltoDisplay,
      }
    case SHOW_TAGS:
      return {
        ...state,
        pkg: action.tPkg,
      }
    case HIDE_TAGS:
      return {
        ...state,
        pkg: [],
      }
    case ASSIGN_TAGS:
      return {
        ...state,
        tags: action.tags,
        colDefns: action.colDefns,
        updTag: true,
      }
    case RESET_UPDTAG:
      return {
        ...state,
        updTag: false,
        tags: ""
      }
    case SHOW_PKGS:
      return {
        ...state,
        data: action.payload.data,
        showPkgs: action.payload.showPkgs
      }
    case HIDE_PKGS:
      return {
        ...state,
        data: [],
        showPkgs: false,
        showNewProj: false
      }
    case CREATE_PKG:
      return {
        ...state,
        crPkg: true,
        packages: []

      }
    case CREATE_PKG:
      return {
        ...state,
        crPkg: false,
        packages: []

      }
    case UPDATE_PKG:
      return {
        ...state,
        updPkg: true,
        packages: action.uPkg.packages
      }
    case HIDE_PKG:
      return {
        ...state,
        crPkg: false,
        updPkg: false,
        packages: []
      }
    case DESTROYED_GRID:
      return {
        ...state,
        destroyedGrid: action.payload
      }
    case CHANGE_WS_TAB:
      return {
        ...state,
        wsTabValue: action.payload
      }
    case FETCH_LOOKUP_START:
      return {
        ...state,
        loading: true
      };
    case FETCH_LOOKUP_SUCCESS: {
      const lookups = action.payload;

      let techTypes = state.techTypes;
      let commercialTypes = state.commercialTypes;
      let commercialProducts = state.commercialProducts;
      let nonConfigProducts = state.nonConfigProducts;
      let waso = state.waso;
      let categories = state.categories;
      let buLkp = state.buLkp;
      let priceListLkp = state.priceListLkp;
      let datasetsLkp = { ...state.datasetsLkp };
      let templates = state.templates;
      let userGuides = state.userGuides;
      let salesChannelName = state.salesChannelName;

      if (lookups['EMR PROJECT WORKSPACE TECHNOLOGY TYPE']) {
        let tT = [];
        lookups['EMR PROJECT WORKSPACE TECHNOLOGY TYPE'].forEach((o) => {
          tT.push({
            lookup_code: o.lookup_code,
            description: o.description,
            technologyId: o.lookup_code,
            division: o.tag,
            category: o.attribute1,
            instrumentType: o.attribute2,
            businessUnits: o.attribute3,
            orgId: o.attribute4,
            type: o.attribute5
          });
        });
        techTypes = tT;
        commercialTypes = [...new Set(tT.filter((i) => i.type === 'COMMERCIAL').map((o) => o.category))];
        commercialProducts = [...new Set(tT.filter((i) => i.type === 'COMMERCIAL').map((o) => o.description))];
        nonConfigProducts = [...new Set(tT.filter((i) => i.orgId === 'FLAT').map((o) => o.description))];
      }

      if (lookups['EMR WORLD AREA SALES ORG']) {
        let cwaso = [];
        lookups['EMR WORLD AREA SALES ORG'].forEach((o) => {
          cwaso.push({ value: o.lookup_code, label: o.description });
        });
        cwaso.sort((a, b) => a.label.toUpperCase().localeCompare(b.label.toUpperCase()));
        waso = cwaso;
      }

      if (lookups['EMR PROJECT WORKSPACE CATEGORIES']) {
        categories = lookups['EMR PROJECT WORKSPACE CATEGORIES'];
      }

      if (lookups['EMR PRJWSC BU OFFICE LIST']) {
        buLkp = lookups['EMR PRJWSC BU OFFICE LIST'];
      }

      if (lookups['EMR PRJWSC PRICELIST']) {
        priceListLkp = lookups['EMR PRJWSC PRICELIST'];
      }

      if (lookups['EMR PRJWSC TEMPLATES']) {
        const templateLookup = lookups['EMR PRJWSC TEMPLATES'];
        templates = templateLookup.filter((item) => (item.tag || '').toUpperCase() === 'TEMPLATE');
        userGuides = templateLookup.filter((item) => (item.tag || '').toUpperCase() === 'GUIDE');
      }

      if (lookups['EMR PRJWSC SALES CHANNEL NAME']) {

        let ChName = [];
        lookups['EMR PRJWSC SALES CHANNEL NAME'].forEach((o) => {
          ChName.push({ value: o.meaning, label: o.description });
        });
        ChName.sort((a, b) => a.label.toUpperCase().localeCompare(b.label.toUpperCase()));
        salesChannelName = ChName;
      }

      // Handle all datasetsLkp
      const datasetMap = {
        'EMR PROJECT WORKSPACE COMMON COLUMNS': 'Common',
        'EMR PROJECT WORKSPACE DP FLOW COLUMNS': 'DP Flow',
        'EMR PROJECT WORKSPACE FLOW COLUMNS': 'Flow',
        'EMR PROJECT WORKSPACE PRESSURE COLUMNS': 'Pressure',
        'EMR PROJECT WORKSPACE TEMPERATURE COLUMNS': 'Temperature',
        'EMR PROJECT WORKSPACE DP LEVEL COLUMNS': 'DP Level',
        'EMR PROJECT WORKSPACE PROCESS LEVEL COLUMNS': 'Process Level',
        'EMR PROJECT WORKSPACE VANESSA COLUMNS': 'Vanessa',
        'EMR PROJECT WORKSPACE DOC & ORD SERVICES COLUMNS': 'Documents & Order Services',
        'EMR PROJECT WORKSPACE BUY RESALE COLUMNS': 'Buy Resale',
        'EMR PROJECT WORKSPACE SPARES COLUMNS': 'Accs, Parts & Spares',
        'EMR PROJECT WORKSPACE FLAME & GAS COLUMNS': 'Flame & Gas',
        'EMR PROJECT WORKSPACE ALL INSTRUMENTATION COLUMNS': 'All Instrumentation'
      };

      Object.entries(datasetMap).forEach(([apiKey, stateKey]) => {
        if (lookups[apiKey]) {
          const tempLkp = lookups[apiKey].sort(
            (a, b) => a.group_sequence - b.group_sequence || a.sequence - b.sequence
          );
          datasetsLkp[stateKey] = tempLkp;
        }
      });

      return {
        ...state,
        techTypes,
        commercialTypes,
        commercialProducts,
        nonConfigProducts,
        waso,
        categories,
        buLkp,
        priceListLkp,
        datasetsLkp,
        templates,
        userGuides,
        salesChannelName,
        loading: false
      };
    }
    case FETCH_LOOKUP_FAILURE:
      return {
        ...state,
        error: ERROR
      };
    case CONF_ROUTING_CHECK_SUCCESS:
      return {
        ...state,
        routingCheckData: action.rspData,
        loadingPhase: { phase: 'SUCCESS', type: "CONF_ROUTING_CHECK", message: "Routing check completed successfully." }
      };
    case CONF_ROUTING_CHECK_START:
      return {
        ...state,
        routingCheckData: null,
        loadingPhase: { phase: 'START', type: "CONF_ROUTING_CHECK", message: "Routing check started." }
      };
    case CONF_ROUTING_CHECK_FAILURE:
      return {
        ...state,
        loadingPhase: { phase: 'FAILURE', type: "CONF_ROUTING_CHECK", message: "Routing check failed." }
      };

    case GET_CONF_SESSIONID_SUCCESS:
      return {
        ...state,
        confSessionIDData: action.rspData,
        loadingPhase: { phase: 'SUCCESS', type: "GET_CONF_SESSIONID", message: "Getting configuration session ID completed successfully." }
      };
    case GET_CONF_SESSIONID_START:
      return {
        ...state,
        confSessionIDData: null,
        loadingPhase: { phase: 'START', type: "GET_CONF_SESSIONID", message: "Getting configuration session ID started." }
      };
    case GET_CONF_SESSIONID_FAILURE:
      return {
        ...state,
        loadingPhase: { phase: 'FAILURE', type: "GET_CONF_SESSIONID", message: "Getting configuration session ID failed." }
      };

    case CONFIT_CREATE_QUOTE_SUCCESS:
      console.log("CONFIT_CREATE_QUOTE_SUCCESS", action.rspData)
      return {
        ...state,
        confCreateQuoteData: action.rspData.OutputParameters,
        loadingPhase: { phase: 'SUCCESS', type: "CONFIT_CREATE_QUOTE", message: "Creating quote completed successfully." }
      };
    case CONFIT_CREATE_QUOTE_START:
      return {
        ...state,
        confCreateQuoteData: null,
        loadingPhase: { phase: 'START', type: "CONFIT_CREATE_QUOTE", message: "Creating quote started." }
      };
    case CONFIT_CREATE_QUOTE_FAILURE:
      return {
        ...state,
        loadingPhase: { phase: 'FAILURE', type: "CONFIT_CREATE_QUOTE", message: "Creating quote failed." }
      };

    case CONFIT_UPDATE_QUOTE_SUCCESS:
      console.log("CONFIT_UPDATE_QUOTE_SUCCESS", action.rspData)
      let rspData = action.rspData
      return {
        ...state,
        confUpdateQuoteData: rspData,
        loadingPhase: { phase: 'SUCCESS', type: "CONFIT_UPDATE_QUOTE", message: "Updating quote completed successfully." }
      };
    case CONFIT_UPDATE_QUOTE_START:
      return {
        ...state,
        confUpdateQuoteData: null,
        loadingPhase: { phase: 'START', type: "CONFIT_UPDATE_QUOTE", message: "Updating quote started." }
      };
    case CONFIT_UPDATE_QUOTE_FAILURE:
      return {
        ...state,
        loadingPhase: { phase: 'FAILURE', type: "CONFIT_UPDATE_QUOTE", message: "Updating quote failed." }
      };
    case SET_CONF_INIT:
      return {
        ...state,
        loadingPhase: { phase: 'INIT', type: "SET_INIT", message: "Initializing configuration." }
      };
    default:
      return state;
  }
}